import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalDataService {
  waiting:boolean = false;
  is_sure:boolean = false;
  deletePostStatus:any = new BehaviorSubject(false);
  storeEditEntity:any = new Subject();
  storePostData:any = new Subject();
  storeEditData:any = new Subject();
  storeBannerLogo:any = new Subject();
  storeProfileLogo:any = new Subject();
  storePostLogo:any = new Subject();
  aboutEntity:any = new Subject();
  constructor() { }
  isChangeFormValue(formValues:any,changeValues:any){
    let status;
    for(let item of Object.keys(formValues)){
      if(JSON.stringify(formValues[item])===JSON.stringify(changeValues[item])){
        status = true;
        // console.log({name:item,value:formValues[item]},{name:item,value:changeValues[item]},status)
      }
      else{
        status = false;
        // console.log({name:item,value:formValues[item]},{name:item,value:changeValues[item]},status)
        break;
      }
    }
    return status;
  }
}
